import { __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
import { setElementFocus, hasSheetClassName, setFocus, defineSheetLayout, trapUpperBoundFocus, trapLowerBoundFocus } from './uitk-sheet-utilities.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkFullSheet = function (props) {
    var ariaLabel = props.ariaLabel, _a = props.autoFocus, autoFocus = _a === void 0 ? true : _a, children = props.children, className = props.className, _b = props.returnFocusOnClose, returnFocusOnClose = _b === void 0 ? true : _b, isVisible = props.isVisible, triggerRef = props.triggerRef, _c = props.theme, theme = _c === void 0 ? 'standard' : _c, _d = props.type, type = _d === void 0 ? 'full' : _d;
    var sheetRef = React.useRef(null);
    var baseClassName = "uitk-".concat(type, "-sheet");
    var sheetClassNames = getClassNameList(baseClassName, className, "".concat(baseClassName, "-").concat(theme));
    // Hooks
    // Set focus when initial mount only
    React.useEffect(function () {
        if (autoFocus && isVisible) {
            setElementFocus(sheetRef, true, true);
        }
        isVisible && hasSheetClassName('add');
    }, [autoFocus, isVisible]);
    // "unmount" hook
    React.useEffect(function () { return function () {
        if (returnFocusOnClose) {
            setFocus(triggerRef);
        }
        hasSheetClassName('remove');
    }; }, [returnFocusOnClose, triggerRef]);
    var _e = defineSheetLayout(children), hasCloseButton = _e.hasCloseButton, layoutProps = _e.layoutProps, closeButtonLayoutProps = _e.closeButtonLayoutProps, closeButtonElem = _e.closeButtonElem, childrenElem = _e.childrenElem;
    return (React.createElement("section", { ref: sheetRef, className: sheetClassNames, tabIndex: -1, role: "dialog", "aria-label": ariaLabel },
        React.createElement("div", { tabIndex: 0, onFocus: trapUpperBoundFocus, "aria-hidden": "true" }),
        hasCloseButton && (React.createElement(UitkLayoutFlex, __assign({}, layoutProps),
            React.createElement(UitkLayoutFlexItem, __assign({}, closeButtonLayoutProps),
                React.createElement("div", null, closeButtonElem)),
            childrenElem && React.createElement(UitkLayoutFlexItem, null, childrenElem))),
        !hasCloseButton && childrenElem,
        React.createElement("div", { tabIndex: 0, onFocus: trapLowerBoundFocus, "aria-hidden": "true" })));
};
UitkFullSheet.displayName = 'UitkFullSheet';

export { UitkFullSheet };
